import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import FileDropBox from "../FileDropBox";
var DataGridParentStack = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (_jsx(Stack, __assign({}, props, { children: _jsx(FileDropBox, { children: children }) })));
};
export default DataGridParentStack;
